import React from 'react'
import { trackEvent } from 'utils/analytics'
import { buildRenderableLinks } from 'utils/socialLinks'
import { SocialIcon, ICON_COLORS } from './socialLinkIcons'

/**
 * SocialLinksRow - compact IG-style social links inside the hero section.
 *
 * Social links are a trust signal, not a content block: a single inline row
 * (brand-colored icon + handle/email text) right below the brand stats.
 * Replaces the old standalone mid-page contact block. The legacy `ctaText`
 * field is intentionally not rendered (prototype leftover, no edit UI).
 */

export default function SocialLinksRow({ contact, teamSlug }) {
  const links = buildRenderableLinks(contact)
  if (links.length === 0) return null

  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 mt-3 text-sm">
      {links.map((link, idx) => (
        <a
          key={idx}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1.5 hover:opacity-70 transition-opacity"
          onClick={() => trackEvent('contact_click', { contact_type: link.type, team_slug: teamSlug })}
        >
          <span aria-hidden="true" className={ICON_COLORS[link.type] || 'text-gray-500'}>
            <SocialIcon type={link.type} className="w-4 h-4" />
          </span>
          <span className="font-medium" style={{ color: '#555555' }}>{link.display}</span>
        </a>
      ))}
    </div>
  )
}
